import React, { useState } from "react";
import { connect } from "react-redux";
import List from "./List";
import Create from "./Create";
import Excelldownload from "./Exceldownload";

import { Layout, Breadcrumb, Row, Col } from "antd";
const { Content } = Layout;

const Attribute = ({ brandList }) => {
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <Layout className="window-frame">
        <Layout className="site-layout">
          <Content className="main-frame-content">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Brands</Breadcrumb.Item>
              <Breadcrumb.Item>All</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame">
              <Row>
                <Col span={24}>
                  <Create
                    setUpdatelist={setUpdatelist}
                    updatelist={updatelist}
                  />
                  <Excelldownload data={brandList} />
                  <h3>Brands</h3>
                  <List updatelist={updatelist} setUpdatelist={setUpdatelist} />
                </Col>
              </Row>
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    brandList: state.brand.brandlist,
  };
};

export default connect(mapStateToProps)(Attribute);
